import { AbstractControl } from '@angular/forms';

// validator that checks if something has been selected in the autocomplete text box
// https://onthecode.co.uk/force-selection-angular-material-autocomplete/
export function requireSelection(control: AbstractControl) {
  const selection: any = control.value;
  if (selection && typeof selection === 'string') {
    return { incorrectSelection: true };
  }
  return null;
}
